// Add this to your theme.js file or create a new request-quote.js file
document.addEventListener("DOMContentLoaded", function () {
  // Get the modal
  var modal = document.getElementById("requestQuoteModal");

  // Get the button that opens the modal
  var btn = document.getElementById("requestQuoteBtn");

  // Get the <span> element that closes the modal
  var span = document.getElementsByClassName("quote-close")[0];

  if (btn && modal) {
    // When the user clicks the button, open the modal
    btn.onclick = function () {
      // Auto-fill product name (already set as value in the hidden input)
      var productTitle = btn.getAttribute("data-product-title");
      document.getElementById("quote-subject").value =
        "Quote Request for " + productTitle;

      // Display the modal
      modal.style.display = "block";
    };

    // When the user clicks on <span> (x), close the modal
    if (span) {
      span.onclick = function () {
        modal.style.display = "none";
      };
    }

    // When the user clicks anywhere outside of the modal, close it
    window.onclick = function (event) {
      if (event.target == modal) {
        modal.style.display = "none";
      }
    };

    // Form validation and submission
    var form = document.getElementById("quoteRequestForm");
    if (form) {
      form.addEventListener("submit", function (event) {
        var allValid = true;

        // Basic validation for required fields
        var requiredFields = form.querySelectorAll("[required]");
        requiredFields.forEach(function (field) {
          if (!field.value.trim()) {
            field.classList.add("error");
            allValid = false;
          } else {
            field.classList.remove("error");
          }
        });

        // Email validation
        var emailField = document.getElementById("quote-email");
        if (emailField && emailField.value) {
          var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!emailRegex.test(emailField.value)) {
            emailField.classList.add("error");
            allValid = false;
          }
        }

        if (!allValid) {
          event.preventDefault();
          alert("Please fill in all required fields correctly.");
        }
      });
    }
  }
});

// Handle product availability changes
document.addEventListener("variant:change", function (event) {
  var variant = event.detail.variant;

  // Get buttons
  var addToCartWrapper = document.querySelector(".product-single__add-to-cart");
  var buyNowWrapper = document.querySelector(".buy-now-button-wrapper");
  var requestQuoteWrapper = document.querySelector(".request-quote-wrapper");

  if (variant && variant.available) {
    // Product is available - show add to cart and buy now buttons, hide request quote
    if (addToCartWrapper) addToCartWrapper.classList.remove("d-none");
    if (buyNowWrapper) buyNowWrapper.classList.remove("d-none");
    if (requestQuoteWrapper) requestQuoteWrapper.classList.add("d-none");
  } else {
    // Product is unavailable - hide add to cart and buy now buttons, show request quote
    if (addToCartWrapper) addToCartWrapper.classList.add("d-none");
    if (buyNowWrapper) buyNowWrapper.classList.add("d-none");
    if (requestQuoteWrapper) requestQuoteWrapper.classList.remove("d-none");
  }
});
